import React from 'react';
import PropTypes from 'prop-types';
import { LineChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line, ResponsiveContainer } from 'recharts'; // eslint-disable-line import/no-unresolved

import { appConfig } from '../../../config/customization';

import CustomActiveDot from './components/CustomActiveDot';
import CustomXAxisLabel from './components/CustomXAxisLabel';
import CustomYAxisLabel from './components/CustomYAxisLabel';
import styles from './styles';

function UTChart({
  data,
  dataKey,
  oldDataKey,
  currentDataKey,
  oldDataName,
  currentDataName,
  activeXAxisValue,
  activeValue,
  unit,
  currencyUnit,
  minWidth,
  minHeight,
  handleClick
}) {
  const formatTooltip = value => `${value} ${unit}`;
  return (
    <div style={styles.container}>
      <ResponsiveContainer minWidth={minWidth} minHeight={minHeight}>
        <LineChart data={data} margin={styles.chart}>
          <XAxis
            axisLine={false}
            tickLine={false}
            tick={
              <CustomXAxisLabel
                activeValue={activeXAxisValue}
                activeColor={appConfig.colors.green}
                inactiveColor={appConfig.colors.gray}
              />
            }
            padding={styles.xAxis}
            tickCount={14}
            dataKey={dataKey}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickCount={6}
            tick={<CustomYAxisLabel unit={unit} currencyUnit={currencyUnit} color={appConfig.colors.gray} />}
          />
          <CartesianGrid vertical={false} />
          <Legend verticalAlign="top" align="right" height={50} iconType="circle" iconSize={10} />
          {oldDataName && (
            <Line
              name={oldDataName}
              type="linear"
              activeDot={false}
              dataKey={oldDataKey}
              dot={<CustomActiveDot color={appConfig.colors.lightBlue} onClick={handleClick} year="last" />}
              strokeWidth={6}
              stroke={appConfig.colors.lightBlue}
              opacity={0.6}
            />
          )}
          {currentDataName && (
            <Line
              name={currentDataName}
              type="linear"
              dataKey={currentDataKey}
              activeDot={false}
              dot={
                <CustomActiveDot
                  activeValue={activeValue}
                  color={appConfig.colors.green}
                  onClick={handleClick}
                  year="current"
                />
              }
              strokeWidth={6}
              stroke={appConfig.colors.green}
              opacity={0.6}
            />
          )}
          <Tooltip
            cursor={false}
            isAnimationActive={false}
            formatter={formatTooltip}
            labelStyle={styles.tooltipText}
            itemStyle={styles.tooltipText}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

UTChart.propTypes = {
  data: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  dataKey: PropTypes.string.isRequired,
  oldDataKey: PropTypes.string.isRequired,
  currentDataKey: PropTypes.string.isRequired,
  oldDataName: PropTypes.string,
  currentDataName: PropTypes.string,
  activeValue: PropTypes.string,
  activeXAxisValue: PropTypes.string,
  unit: PropTypes.string,
  currencyUnit: PropTypes.bool,
  minWidth: PropTypes.number.isRequired,
  minHeight: PropTypes.number.isRequired,
  handleClick: PropTypes.func
};

export default UTChart;
